import debounce from "lodash/debounce";
import React from "react";
import styled from "styled-components";

const InputField = styled.input`
    width: 100%;
    background-color: transparent;
    border: none;
    border-bottom: solid 2px ${({ theme }) => theme.newBg3};
    padding: 0.5rem;
    border-radius: 0;
    outline: none;
    color: ${({ theme }) => theme.text1};

    &:hover {
    border: none;
    border-bottom: solid 2px ${({ theme }) => theme.newBg1};
    }

    &:focus {
    border: none;
    border-bottom: solid 2px ${({ theme }) => theme.newBg1};
    }

    &.error {
    border-bottom: solid 2px ${({ theme }) => theme.red2};
    }
`

interface IInputProps {
    value?: string;
    placeholder?: string;
    isValid?: boolean;
    onChange?: (value: string) => void;
}

//create Input Component from InputField
const Input = ({ isValid, onChange, placeholder, value }: IInputProps) => {

    const [inputValue, setInputValue] = React.useState(value);

    const onChangeDebounced = React.useCallback(debounce((value: string) => {
        if (onChange) {
            onChange(value);
        }
    }, 300), []);

    const _onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        e.persist();
        onChangeDebounced(e.target?.value);
        setInputValue(e.target?.value);
    }

    return (
        <InputField
            className={isValid === false ? 'error' : ''}
            placeholder={placeholder}
            value={inputValue}
            onChange={_onChange}
        />
    )
}
export default Input;
